import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.editAccount.loading;
export const selectErrorMessage = (state: RootState) => state.editAccount.error;
export const editAccountDataResponse = (state: RootState) =>
  state.editAccount.editAccountResponse;
